import type { MotionValue } from "framer-motion";
import landscapeDistantEvening from "../../../assets/landscape-distant-evening.webp?inline";
import landscapeDistantHills from "../../../assets/landscape-distant-hills.webp?inline";
import { CrossfadeParallaxLayer } from "../../../shared/landscape/crossfade-parallax-layer";

type TLandscapeDistantProps = {
	y: MotionValue<number>;
	eveningOpacity: MotionValue<number>;
};

export function LandscapeDistant({ y, eveningOpacity }: TLandscapeDistantProps) {
	return (
		<CrossfadeParallaxLayer
			y={y}
			eveningOpacity={eveningOpacity}
			daySrc={landscapeDistantHills}
			eveningSrc={landscapeDistantEvening}
			scale={1}
			className="absolute z-[1] pointer-events-none select-none right-0 bottom-[calc(4%-120px)] left-0 h-[max(32%,21vw)] max-md:right-[-38%] max-md:left-[-38%] max-md:bottom-[8%] max-md:w-[176%] max-md:h-[max(29%,37vw)] [mask-image:linear-gradient(to_bottom,transparent_0%,color-mix(in_srgb,var(--color-black)_35%,transparent)_12%,black_28%,black_100%)] [-webkit-mask-image:linear-gradient(to_bottom,transparent_0%,color-mix(in_srgb,var(--color-black)_35%,transparent)_12%,black_28%,black_100%)] [mask-size:100%_100%] [-webkit-mask-size:100%_100%]"
		/>
	);
}
